import * as React from 'react';
import useJackpotTileIncrement from '../../../../hooks/useJackpotTileIncrement';
import { JackpotNumber, JackpotNumberProps } from './JackpotNumber';

interface JackpotNumberDynamicProps extends JackpotNumberProps {
  timestamp: number;
}

export const JackpotNumberDynamic: React.FC<JackpotNumberDynamicProps> = props => {
  const { value, timestamp, ...propsToForward } = props;
  const calculatedValue = useJackpotTileIncrement(value, timestamp);
  return <JackpotNumber {...propsToForward} value={calculatedValue} />;
};
